const dateUtils = {
    //获取当前时间的格式化日期
    dateFormat(){
        let date = new Date();
        return date.getFullYear()+""+(date.getMonth()+1)+""+date.getDate();
    },
}
export default dateUtils